import { setCookie, getCookie, getVisitType, getParameter } from 'utils/common'
import API from 'api'

export default {
  namespaced: true,
  state: {
    init: false,
    params: {
      cookid: getCookie('cookieId') || getCookie('vivo_fe_vftcookid'),
      openid: '',
      imei: getCookie('vvc_imei'),
      vaid: getCookie('vvc_vaid') || '',
      oaid: getCookie('vvc_oaid') || '',
      aaid: getCookie('vvc_aaid') || '',
      visittime: Date.now(),
      cid: getCookie('vfe-cid'),
      cid_eff_ts: getCookie('cid_eff_ts') || '',
      cid_ref: getCookie('cid_ref') || '',
      sessionid: getCookie('vivo_fe_vftsessionid'),
      version: '995',
      visittype: getVisitType(),
      dm: location.host,
      url: location.pathname,
      arg: location.search.substring(1),
      title: document.title,
      ref_url: document.referrer
    },
    // app埋点通用参数
    appParams: {
      cid: getCookie('vfe-cid'),
      cid_eff_ts: getCookie('cid_eff_ts') || '',
      cid_ref: getCookie('cid_ref') || ''
    }
  },
  mutations: {
    SET_AUTH_STATE(state, init) {
      state.init = init
    },
    SET_COOKIEID({ params }, cookieId) {
      params.cookid = cookieId
    },
    SET_SESSIONID({ params }, sessionId) {
      params.sessionid = sessionId
    },
    SET_OPENID({ params }, openId) {
      params.openid = openId
    },
    SET_CID({ params, appParams }, cid) {
      params.cid = cid
      appParams.cid = cid
    },
    SET_CID_TIME({ params, appParams }, time) {
      params.cid_eff_ts = time
      appParams.cid_eff_ts = time
    },
    SET_CID_REF({ params, appParams }, url) {
      params.cid_ref = url
      appParams.cid_ref = url
    },
    SET_REFERRER({ params }, referrer) {
      params.ref_url = referrer
    },
    SET_URL_DATA({ params }, { path, argStr = '', title }) {
      params.url = path
      params.arg = argStr
      params.title = title
    }
  },
  actions: {
    initAuthInfo({ state, commit, dispatch }) {
      // 更新cid
      dispatch('updateCid')
      // 获取认证信息
      return API.initAuthInfo().then(data => {
        if (!data) return

        // 检查当前本地是否已存在游客和当前会话的标识，如果存在，则使用已经存在的
        if (!state.params.cookid) {
          commit('SET_COOKIEID', data.cookieId)
          setCookie('vivo_fe_vftcookid', data.cookieId)
        }

        if (!state.params.sessionid) {
          commit('SET_SESSIONID', data.fakeSessionId)
          setCookie('vivo_fe_vftsessionid', data.fakeSessionId)
        }

        // 如果 vivo_account_cookie_iqoo_openid 属性存在，则表示登录过了，记录登录唯一ID
        if (data.vivo_account_cookie_iqoo_openid) {
          commit('SET_OPENID', data.vivo_account_cookie_iqoo_openid)
          // 暂存登录态，方便后续动作使用
          setCookie('login_flag_tmp', 1)
        } else {
          setCookie('login_flag_tmp', 0)
        }

        commit('SET_AUTH_STATE', true)

        // 是否展示客户端头部，临时处理方式
        if (data.navigation_bar_switch === '1') {
          sessionStorage.setItem('navigation_bar_switch', '1')
        } else {
          sessionStorage.setItem('navigation_bar_switch', '0')
        }
      })
    },
    // 更新cid信息
    updateCid({ commit }) {
      // 存储外部来源cid
      let cid = getParameter('cid') || getCookie('vfe-cid') || ''
      if (cid) {
        setCookie('vfe-cid', cid)
        commit('SET_CID', cid)
        // 外部来源更新时间
        const time = Date.now()
        setCookie('cid_eff_ts', time)
        commit('SET_CID_TIME', time)
        // 储存cid来源，方便追踪来源
        let url = window.location.href
        setCookie('cid_ref', url)
        commit('SET_CID_REF', url)
      }
    },
    // 单页路由跳转时，更新url相关的数据
    updateTrackData({ commit, dispatch }, data) {
      // 更新cid信息
      dispatch('updateCid')
      if(data?.path) {
        commit('SET_URL_DATA', data)
      }
    },
    updateReferrer({ commit }, referrer) {
      commit('SET_REFERRER', referrer || document.referrer)
    }
  }
}
